module.exports = new __parcel__URL__("is-this-the-life-we-really-want.30f36fe5.jpg").toString();